export const GET_VERIFICATION_LINK = 'GET_VERIFICATION_LINK';
export const GET_VERIFICATION_LINK_SUCCESS = 'GET_VERIFICATION_LINK_SUCCESS';
export const GET_VERIFICATION_LINK_FAIL = 'GET_VERIFICATION_LINK_FAIL';

export const CHECK_KYC_STATUS = 'CHECK_KYC_STATUS';
export const CHECK_KYC_STATUS_SUCCESS = 'CHECK_KYC_STATUS_SUCCESS';
export const CHECK_KYC_STATUS_FAIL = 'CHECK_KYC_STATUS_FAIL';

export const UPDATE_PROFILE_AFTER_KYC = 'UPDATE_PROFILE_AFTER_KYC';
